// @flow
import React from 'react';
import { connect } from 'react-redux';
// Components
import LoggedInOptions from '../components/LoggedInOptions';
import LoggedInSkeleton from '../components/LoggedInSkeleton';
import LoggedOutOptions from '../components/LoggedOutOptions';
// Types
import type { Connector } from 'react-redux';
// Selectors
import {
  firstNameSelector,
  loggedInSelector,
  validatingUserLoadingSelector,
  isUserValidatedSelector,
} from '../selectors';

type Props = {
  loggedIn: boolean,
  firstName: string,
  validatingUserLoading: boolean,
  isUserValidated: boolean,
};

const CurrentUserIndicator = ({
  loggedIn,
  firstName,
  validatingUserLoading,
  isUserValidated,
}: Props) => {
  if (validatingUserLoading || !isUserValidated) {
    return <LoggedInSkeleton />;
  }

  if (loggedIn && isUserValidated && !validatingUserLoading) {
    return <LoggedInOptions name={firstName} />;
  }

  return <LoggedOutOptions />;
};

const mapStateToProps = (state, ownProps) => {
  return {
    loggedIn: loggedInSelector(state),
    firstName: firstNameSelector(state),
    isUserValidated: isUserValidatedSelector(state),
    validatingUserLoading: validatingUserLoadingSelector(state),
  };
};

const connector: Connector<{}, Props> = connect(mapStateToProps);
export default connector(CurrentUserIndicator);
